import { h } from 'preact'
import SingleChart from './single-chart'
import { BankData } from 'src/assets/scripts/models/market'
import { formatNumber, formatRate } from 'utils/format-number'

interface SingleBankRowProps {
  bankData: BankData
  buyCurrency: string
  sellCurrency: string
  banksData?: BankData[]
  isFirstRow?: boolean
}

const SingleBankRow = ({ bankData, buyCurrency, sellCurrency, banksData, isFirstRow }: SingleBankRowProps) => {
  const addWtClass = isFirstRow ? 'is-wt' : ''
  const currencyPair = `${buyCurrency}_${sellCurrency}`

  return (
    <div className={`calculator-chart__single-chart-row ${addWtClass}`}>
      <div className="calculator-chart__single-cell is-wide">
        <SingleChart
          bankName={bankData.bank_display_name}
          offerPercentage={bankData.offer_percent}
          banksData={banksData}
        />
      </div>
      <div className="calculator-chart__single-cell">
        <p className="calculator-chart__row-value">{formatRate(bankData.rate, currencyPair)}</p>
      </div>
      <div className="calculator-chart__single-cell is-padding">
        <p className="calculator-chart__row-value">
          {formatNumber(bankData.amount, 2)} {sellCurrency}
        </p>
      </div>
    </div>
  )
}

export default SingleBankRow
